import { render, staticRenderFns } from "./internal-training.vue?vue&type=template&id=647fe039"
import script from "./internal-training.vue?vue&type=script&lang=ts"
export * from "./internal-training.vue?vue&type=script&lang=ts"
import style0 from "./internal-training.vue?vue&type=style&index=0&id=647fe039&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports